import { parseAccountNumberFinland } from "@stacc/bank-validation";
import { checklistOptions, insuranceChecklistOptions } from "./options";

export function validateChecklist(checklist: any) {
  if (checklist.length === 0) {
    return "Please go through the checklist.";
  }
  const missingChecklistItems = checklistOptions.filter(
    (option) => !checklist.includes(option.value)
  );
  if (missingChecklistItems.length > 0) {
    return `Please select the following checklist items: ${missingChecklistItems.map((item) => item.label).join(", ")}`;
  }
  const missingInsuranceItems = insuranceChecklistOptions.filter(
    (option) => !checklist.includes(option.value)
  );
  if (missingInsuranceItems.length > 0) {
    return `Please select the following insurance checklist items: ${missingInsuranceItems.map((item) => item.label).join(", ")}`;
  }
  return null;
}

export function validateDecision(decision: any) {
  if (decision === null) {
    return "Please select a decision.";
  }
  return null;
}

export function validateInsurance(insurance: any) {
  if (insurance === null) {
    return "Please select an insurance option.";
  }
  return "";
}

/**
 * Validates a Finnish bank account number (IBAN). Returns an error message when
 * the value is missing or fails IBAN parsing/checksum, otherwise null.
 * @param accountNumber - The account number entered by the caseworker
 * @param fieldLabel - Human-readable field name used in the error message
 */
export function validateAccountNumberFinland(
  accountNumber: string | null | undefined,
  fieldLabel: string
): string | null {
  if (!accountNumber) {
    return `${fieldLabel} is required.`;
  }
  try {
    parseAccountNumberFinland(accountNumber);
    return null;
  } catch {
    return `${fieldLabel} is not a valid Finnish account number (IBAN).`;
  }
}
